<template>
  <transition name="fade" mode="out-in">

    <div class="app c-app flex-row align-items-center">

      <CContainer>
        <CRow class="justify-content-center align-items-center">

          <CCol md="12" >

            <CCardGroup align="center" class="d-flex justify-content-center align-items-center" >

              <CCard class="login-container animated zoomIn faster"
               :class="{ 'register-container': currentStep > 1, 'register-container-video': currentStep == 1,'register-container-test': (currentStep == 1 ) && !testA}">
                <CCardBody>

                  <div style="width: 100%;padding-bottom: 50px; margin-top: 1.5rem" :style="{ 'padding-bottom': heightLogo + 'px'}">
                    <div class="col-md-12" style="align-content: center;text-align: center;">
                      <!-- <img class="navbar-brand-full logo" src="logo/logo.png" height="70" alt="MIMOTO - Área privada clientes MimoTo"> -->
                      <img class="navbar-brand-minimized" src="logo/logo.png"  height="50" alt="MIMOTO - Área privada clientes MimoTo">
                      <div>
                        <router-link to="/login" class="new-account">¿Ya tienes cuenta en mimoTo? Acceso socios</router-link>
                      </div>
                    </div>
                  </div>

                  <div class="register-title" :class="{'mb-5' : !isMobile}">

                    <h1 v-if="currentStep===1" class="bold">
                      {{'consigue gratis tu llave'.toUpperCase()}}
                    </h1>

                    <h1 v-if="currentStep===2">
                      {{'Añade tu contraseña para acceder a tu área de clientes.'}}
                    </h1>

                    <h1 v-if="currentStep===3" class="bold">
                      BIENVENIDO A {{ companyName.toUpperCase() }}
                    </h1>
                  </div>


                  <CRow style="width: 100%; padding-bottom: 20px;" :style="{ 'padding-bottom': selectedPadding + 'px'}">
                      <progressTracker :step="currentStep" @step="setStep"></progressTracker>
                  </CRow>

                  <div class="title-container">

                    <router-view
                      @updateStep="updateStep"
                      @validForm="toggleButtons"
                      @showNext="displayNext"
                      @showPrev="displayPrev"
                      @showButtons="displayButtons"
                    ></router-view>

                  </div>

                  <div class="mt-4 register-footer-links">
                    <a :href="'https://wa.me/+34' + MIMOTO_WHATSAPP.number" target="_blank">
                      <CIcon name="cib-whatsapp"/> {{ MIMOTO_WHATSAPP.label }}
                    </a>

                    <a :href="'tel:+' + MIMOTO_PHONE.number" target="_top">
                      <CIcon name="cil-phone"/> {{ MIMOTO_PHONE.label }}
                    </a>

                    <a href="https://mimotoparking.com/contacto/" target="_blank">
                      <strong>{{ MIMOTO_MAIL.label }}</strong>
                    </a>
                  </div>


                  <div class="mt-4 logos-footer">
                    <img class="single-logo" :src="require('@/assets/img/logo-feder.png')" height="60" alt="">
                    <!-- <img class="single-logo" :src="require('@/assets/img/sello-eu-75-1-r.png')" height="70" alt=""> -->
                    <img class="single-logo" :src="require('@/assets/img/logo-ivace-gva.png')" height="50" alt="">
                  </div>  


                  <div class="mt-4 terms-container legal">
                    <b>Información básica en protección de datos:</b>
                    Conforme al RGPD y la LOPDGDD, MIMOTO PARKING SL tratará los datos facilitados, con la finalidad de registrarle en la
                    plataforma web de la entidad y generar un usuario y contraseña que le permita acceder a su cuenta/perfil. Siempre que
                    nos lo autorice previamente, enviaremos información relacionada con los servicios ofrecidos por la entidad. Podrá
                    ejercer, si lo desea, los derechos de acceso, rectificación, supresión, y demás reconocidos en la normativa
                    mencionada. Para obtener más información acerca de cómo estamos tratando sus datos, acceda a nuestra <a
                      class="link-terms" href="https://mimotoparking.com/politica-privacidad/" target="_blank">política de
                      privacidad.</a>
                  </div>


               </CCardBody>
            </CCard>
          </CCardGroup>


        </CCol>
        </CRow>
      </CContainer>

      <!-- <div class="buttons-row row" :class="{ 'max-width': currentStep == lastStep }">
        <div class="col-6 p-0 text-left">
          <button
            v-if="showPrevious"
            type="button"
            class="btn btn-info mr-1"
            :disabled="previousDisabled"
            @click.prevent="prevStep"
          >
            <font-awesome-icon icon="chevron-left" />Anterior
          </button>
        </div>
        <div class="col-6 p-0 text-right">
          <button
            v-if="showNext"
            type="button"
            class="btn btn-info ml-1"
            :disabled="nextDisabled"
            @click.prevent="nextStep"
          >
            Siguiente
            <font-awesome-icon icon="chevron-right" />
          </button>
        </div>
      </div> -->

      <toast ref="toast"></toast>
    </div>
  </transition>
</template>

<script>

import progressTracker from '@/app/shared/components/ProgressTracker';
import {MIMOTO_PHONE, MIMOTO_WHATSAPP, MIMOTO_MAIL} from '@/config';

export default {
  name: "registro-cliente",
  components: {
    progressTracker,

  },
  data() {
    return {
      showNext: false,
      showPrevious: false,
      nextDisabled: false,
      previousDisabled: false,
      currentStep: 1,
      lastStep: 3,
      nextRoute: null,
      previousRoute: null,
      currentStepComponent: null,
      // step: 1,
      MIMOTO_PHONE: MIMOTO_PHONE,
      MIMOTO_WHATSAPP: MIMOTO_WHATSAPP,
      MIMOTO_MAIL: MIMOTO_MAIL,

    };
  },
  created() {
    window.scrollTo(0, 0);
    this.checkSteps();

    // console.log(this.$test);
  },

  computed: {
    selectedPadding() {
      return this.currentStep == 1 ? 0 : 20;
    },
    isMobile() {
      return window.screen.width <= 430 ? true: false;
    },
    heightLogo() {
      return window.screen.width <= 430 ? 20: 50;
    },
    testA() {
      return this.$test == 'A'; 
    },
    companyName() {
      return process.env.VUE_APP_COMPANY_NAME; 
    },
  },

  methods: {
    checkSteps() {
      if (this.currentStep === 1) {
        this.showNext = true;
        this.showPrevious = false;

        return;
      } else if (this.currentStep === this.lastStep) {
        this.showNext = false;
        this.showPrevious = true;

        return;
      }

      if (this.currentStep === "error") {
        this.showNext = false;
        this.showPrevious = false;

        return;
      }

      this.showNext = true;
      this.showPrevious = true;
    },
    toggleButtons(isValid) {
      if (!isValid) {
        //this.nextDisabled = true;
      } else {

        this.displayStep(this.currentStep + 1);
       // this.$router.push(this.$router.options.routes[this.currentStep + 1]);
      }
    },
    updateStep(step) {
      this.nextDisabled = false;
      this.currentStep = step.step;
      this.currentStepComponent = step;
      this.checkSteps();
    },
    setStep(step) {
      this.currentStep = step;
      this.displayStep(step);
    },
    prevStep() {
      this.displayStep(this.currentStep -1);
      //this.$router.push(this.$router.options.routes[this.currentStep - 1]);
    },
    nextStep() {

      this.toggleButtons(true);

      // if (this.currentStep == 2) {
      //   this.toggleButtons(true);
      // } else {
      //   this.currentStepComponent.checkValidForm();
      // }
    },
    displayButtons(value) {
      this.showNext = value;
      this.showPrevious = value;
    },
    displayPrev(value) {
      this.showPrevious = value;
    },
    displayNext(value) {
      this.showNext = value;
    },
    displayStep(currentStep){
      switch (currentStep) {
        case 1:
          // this.$router.push(`/clientes/personal${this.$test}`);
          this.$router.push(`/clientes/personal`);
        case 2:
          this.$router.push(`/clientes/password`);
          break;
        // case 3:
        //   this.$router.push(`/clientes/phone`);
        //   break;
        // case 4:
        //   this.$router.push(`/clientes/credit_card`);
        //   break;
        case 3:
          this.$router.push(`/clientes/acceso`);
          break;
        case 6:
          // this.$router.push(`/clientes/registro/5`);
          break;
        default:
        //   this.$router.push(`/clientes/inscripcion`);
          break;
      }
    }

  }
};
</script>

<style lang="scss">

@import '~@/assets/scss/mimoto.scss';

// .app {
//   width: 100%;
//   // min-height: 160vh;
//   background-image: url("~@/assets/img/login-background.jpg");
//   background-size: cover;
//   background-repeat: no-repeat;
//   background-position: left top;
//   // margin-top: $header;
//   position: relative;

//   @media (min-width: 768px) {
//     min-height: 100vh;
//   }

//   & > * {
//     z-index: 2;
//   }

//   &::after {
//     content: "";
//     position: absolute;
//     top: 0;
//     left: 0;
//     background-color: rgba(#a8d7e7, 0.5);//#f3f6f9; #A6C4CE  2d5b83
//     width: 100%;
//     height: 100%;
//     z-index: 1;
//     opacity: 0.9;
//   }

//   .register-title {
//     font-family: $varela;
//   }

// }

.register-title  {

  h1 {
    margin-bottom: 20px;

    &.bold {
      font-weight: bold;
    }
  }

}

.text-sms-confirm {
  font-size: 16px;
  color: #162d3d !important;
  font-family: "MuseoSans-100" !important;

}
.login-text {
  color: $black !important;
}
.sms-confirm-container {
  width: 60%;
  margin: auto;
  margin-top: 10px;
  padding: 20px;
  border-radius: 20px;

  input {
    width: 150px;
    font-size: 23px !important;
  }
}
.list-bennefit {
    padding: 2rem 3rem;
    line-height: 1.8;
    text-align: left;
    p {
      color: $black !important;
      font-weight: 600 !important;
    }
    .c-icon {
      color: #82C91E;
      margin-right: 1.2rem;
    }
  }
.footer-subtitle {
  color: #353535;
  margin-top: 15px;
}

.register-footer-links {
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  // display: inline-grid;
  // // grid-template-columns: repeat(3,  minmax(166px, 1fr));
  // grid-template-columns: repeat(auto-fit, minmax(166px, 1fr));


  color: #3899EC;
  font-family: "MuseoSans-300";
  font-size: 0.87rem;

  a:hover {
    color: #82C91E;
  }
}

.register-no-card {

  a {

    &:hover {
      font-weight: 600;
      color: #82C91E;
    }
  }

}


.logos-footer {
  display: flex;
  flex-direction: row; 
  align-items: center;
  // justify-content: center;
  justify-content: space-between;
}

.single-logo {
  margin: 0 10px; 
}

@media (max-width: 478px) {
  .logos-footer {
    flex-direction: column; 
    justify-content: center; 
  }

  .single-logo {
    margin: 10px 0;
  }
}



//// video cover

.box-video{
  position: relative;
  width: 100%;
  margin:0 auto 20px auto;
  cursor: pointer;
  overflow: hidden;
  color: rgb(69, 159, 220);
}

 /* Set Cover aka Background-Image */
.box-video .bg-video{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  z-index: 2;
}

 /* Add light shade to make play button visible*/
.bg-video::after{ 
	content:'';
	position: absolute;
  	top: 0;
  	left: 0;
  	width: 100%;
  	height: 100%;
  	background-color: rgba(0,0,0,0.1);
  	z-index: 3;
}


/* The Play-Button using CSS-Only */
.box-video .bt-play {
  position: absolute;
  top:50%;
  left:50%;
  margin:-30px 0 0 -30px;
  display: inline-block;
  width: 60px;
  height: 60px;
  background: rgba(255,255,255,0.3);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  border-radius: 50%;
  text-indent: -999em;
  cursor: pointer;
  z-index:2;
  -webkit-transition: all .3s ease-out;
  transition: all .3s ease-out;
}

/* The Play-Triangle */
.box-video .bt-play:after {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  height: 0;
  width: 0;
  margin: -12px 0 0 -6px;
  border: solid transparent;
  border-left-color: #000;
  border-width: 12px 20px;
  -webkit-transition: all .3s ease-out;
  transition: all .3s ease-out;
}

.box-video:hover .bt-play {
  transform: scale(1.1);
}

/* When Class added the Cover gets hidden... */
.box-video.open .bg-video{
  visibility: hidden;
  opacity: 0;

  -webkit-transition: all .6s .8s;
  transition: all .6s .8s;  
}

/* and iframe shows up */
.box-video.open .video-container{
  opacity: 1;
  -webkit-transition: all .6s .8s;
  transition: all .6s .8s;
}

/* Giving the div ratio of 16:9 with padding */
.video-container {
	position: relative;
	width: 100%;
	height: 0;
  margin: 0;
  z-index: 1;
	padding-bottom: 56.27198%;
}

.video-container iframe {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}


</style>
